import{CdsControl as s}from"@cds/core/forms";import e from"./input.element.scss.js";class t extends s{static get styles(){return[...super.styles,e]}}export{t as CdsInput};
